import "./DefectFilter.scss";
import FilterTypeMenu from "@/components/Common/FilterTypeMenu/FilterTypeMenu.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";

export default {
  name: "DefectFilter",
  components: { FilterTypeMenu, TreeViewSelection },
  props: ["filter", "defectCategories", "persons"],
  data: () => ({
    filterStates: [
      { text: "Meldung abgegeben", value: "created" },
      { text: "Meldung in Bearbeitung", value: "in progress" },
      { text: "Meldung abgeschlossen (erfolgreich)", value: "successfull" },
      { text: "Meldung abgeschlossen (nicht erfolgreich)", value: "failed" }
    ],
    selectedState: [],
    selectedCategory: [],
    selectedPersons: [],
    dialog: false
  }),
  computed: {
    mappedPersons() {
      return this.persons.map(person => ({
        ...person,
        label: `${person.first_name} ${person.last_name}`
      }));
    },
    filteredPersons() {
      return this.filter.responsiblePersons?.$in ?? [];
    },
    selectedCategories() {
      return [];
    }
  },
  methods: {
    async resetFilter() {
      this.$emit("resetFilter", {});
    },
    async filterForDefects() {
      this.$emit("setFilter", this.filter);
    },
    async setFilterState(state) {
      if (!state.value) return;
      if (state?.value === this.filter.state) {
        this.filter.state = null;
        this.selectedState = [];
      } else {
        this.filter.state = state?.value;
        this.selectedState = [state.value];
      }

      this.selectedState.reverse().reverse();
      this.$emit("setFilter", this.filter);
    },
    setFilterCategories(category) {
      if (!category?._id) return;
      if (this.filter.category?.includes(category._id)) {
        this.filter.category = "";
        this.selectedCategory = [];
      } else {
        this.filter.category = category._id;
        this.selectedCategory = [category._id];
      }

      this.selectedCategory.reverse().reverse();
      this.$emit("setFilter", this.filter);
    },
    setFilterPersons(person) {
      if (!person?._id) return;
      if (this.filter.responsiblePersons?.$in?.includes(person._id)) {
        this.filter.responsiblePersons.$in = this.filter.responsiblePersons.$in.filter(
          p => p !== person._id
        );
        this.selectedPersons = this.selectedPersons.filter(
          p => p !== person._id
        );
      } else {
        if (!this.filter.responsiblePersons?.$in) {
          this.filter.responsiblePersons = { $in: [] };
        }
        this.filter.responsiblePersons.$in.push(person._id);
        this.selectedPersons.push(person._id);
      }

      this.selectedPersons.reverse().reverse();
      this.$emit("setFilter", this.filter);
    }
  }
};
